import { createContext } from 'react';

// Undefined keeps breadcrumbs inline; null waits for the layout target to mount.
const BreadcrumbsTargetContext = createContext<HTMLDivElement | null | undefined>(undefined);

export default BreadcrumbsTargetContext;
